function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9993 9.00039C19.9993 9.56973 19.5194 10.0316 18.9279 10.0316H3.74531L9.66795 15.4726C10.0976 15.866 10.113 16.5213 9.70424 16.9308C9.29549 17.343 8.61746 17.3578 8.18915 16.9657L0.332009 9.74697C0.12 9.55228 0 9.28235 0 9.00039C0 8.71843 0.12 8.4485 0.332054 8.25381L8.1892 1.03506C8.61746 0.642971 9.29549 0.657752 9.70424 1.06995C10.113 1.47815 10.0977 2.13343 9.66799 2.52823L3.74531 7.96914H18.9279C19.5194 7.96914 19.9993 8.43106 19.9993 9.00039Z",
  fill: "#222222"
});

function SvgNavigationLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationLeft);
export default __webpack_public_path__ + "static/media/navigation-left.e7c9aed2.svg";
export { ForwardRef as ReactComponent };